import React from 'react';
import Menu from './../../components/menu';

export default function Delivery(){
  return(
    <div>
      <Menu />
    </div>
  );
}